// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.875}
        d="M3.33317 10.0003V10.8337C3.33317 14.5156 6.31794 17.5003 9.99984 17.5003C12.0542 17.5003 13.8916 16.5711 15.1145 15.11M1.6665 1.66699L18.3332 18.3337M13.3332 8.66699V5.83366C13.3332 3.99271 11.8408 2.50033 9.99984 2.50033C9.20032 2.50033 8.46655 2.78181 7.89222 3.25107M9.99984 14.167C8.15889 14.167 6.6665 12.6746 6.6665 10.8337V6.66699L12.7344 12.7403C12.1319 13.6028 11.1318 14.167 9.99984 14.167Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0H20V20H0z" />
      </clipPath>
    </defs>
  </svg>
);
const IconMicrophoneOff = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconMicrophoneOff;
